import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Customer } from '../../../../customer/interfaces/customer';
import { CustomerAutocomplete } from '../../../../customer/interfaces/customer-autocomplete';


export function customerValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        return isCustomerAutocomplate(value) ? null : { invalidCustomer: true };
    };
}

export function isCustomerAutocomplate(obj: any): obj is CustomerAutocomplete {

    return obj && typeof obj === 'object' && 'idregistry' in obj && typeof obj.idregistry === 'number';
}
